import invariant from 'tiny-invariant';
import { app2Service } from './zoomServices';

export function layoutsList(productID) {
  return app2Service()
    .get(`layouts/getLayouts`, {
      params: {
        productID,
      },
    })
    .then((result) => result.data);
}

export function savedLayoutsList(productID) {
  invariant(typeof productID === 'number');
  let url = 'userProject/getSavedLayouts';
  return app2Service()
    .get(url, {
      params: {
        productID,
      },
    })
    .then((result) => {
      return result.data;
    });
}

export async function deleteSavedLayout(layoutID) {
  let url = 'userProject/deleteSavedLayout?layoutID=' + layoutID;
  const response = await app2Service().get(url);
  invariant(response.status === 200);
}
